/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { css, cx } from "@panda/css";

const sizes = {
	sm: { dim: 16, border: 2 },
	md: { dim: 24, border: 2 },
	lg: { dim: 32, border: 3 },
	xl: { dim: 48, border: 4 },
} as const;

type SpinnerSize = keyof typeof sizes;

export interface CosmosSpinnerProps {
	/** Spinner diameter. @default "md" */
	size?: SpinnerSize;
	/** Accessible label. @default "Loading" */
	label?: string;
	/** Additional CSS class. */
	className?: string;
}

const spinnerStyle = css({
	display: "inline-block",
	borderRadius: "50%",
	borderStyle: "solid",
	borderColor: "eds.palette.grayscale.gray020",
	borderTopColor: "eds.palette.blue.400",
	animation: "spin 0.7s linear infinite",
});

export const CosmosSpinner = ({ size = "md", label = "Loading", className }: CosmosSpinnerProps): React.JSX.Element => {
	const { dim, border } = sizes[size];
	return (
		<div
			role="progressbar"
			aria-label={label}
			className={cx(spinnerStyle, className)}
			style={{ width: dim, height: dim, borderWidth: border }}
		/>
	);
};
